
















import { Component, Mixins, Vue } from 'vue-property-decorator';
import GExamCreateFormFormat from '../GExamCreateFormFormat.vue';
import GExamCreateBaseSettingDateSpan from '@/views/GExamCreate/BaseSetting/GExamCreateBaseSettingDateSpan.vue';
import GExamCreateBaseSettingTitleLanguage from '@/views/GExamCreate/BaseSetting/GExamCreateBaseSettingTitleLanguage.vue';
import { GEnum } from '@/constants/enum.defination';
import { EvalSetting } from '@/models/evalSetting/eval-setting';
import { evalSettingModule } from '@/store/modules/entities/eval-setting.module';
import { email, required } from 'vuelidate/lib/validators';
import { GPageBase } from '@/mixins';
import GVTag from '@/components/GVTag.vue';
import { EvalSettingTitleLang } from '@/models/evalSetting/eval-setting-title-lang';

@Component({
  name: 'GExamCreateBaseSetting',
  components: {
    GVTag,
    GExamCreateBaseSettingDateSpan,
    GExamCreateFormFormat,
    GExamCreateBaseSettingTitleLanguage,
  },
  computed: {},
  methods: {},
  validations: {
    evalSettingDetail: {
      title: { required },
    },
  },
})
export default class GExamCreateBaseSetting extends Mixins(GPageBase) {
  mounted() {}

  get radioLabelPersonalReportDisplayTypeSelfGrowthSupport(): GEnum.PersonalReportDisplayType {
    return GEnum.PersonalReportDisplayType.SelfGrowthSupport;
  }

  get radioLabelPersonalReportDisplayTypeDiscoverStrengths(): GEnum.PersonalReportDisplayType {
    return GEnum.PersonalReportDisplayType.DiscoverStrengths;
  }

  get evalSettingDetail(): EvalSetting {
    return evalSettingModule.evalSettingDetail;
  }

  get titleLanguages(): EvalSettingTitleLang[] {
    return this.evalSettingDetail.titleLangs;
  }

  get isTitleInvalid(): boolean {
    return this.$v.evalSettingDetail.title.$dirty && this.$v.evalSettingDetail.title.$invalid;
  }

  get isValid(): boolean {
    const { gExamCreateSpan }: any = this.$refs;
    this.$v.evalSettingDetail.title.$touch();
    gExamCreateSpan.touch();
    let titleLang = true;
    const data = this.titleLanguages.map((tl: EvalSettingTitleLang)=>{
      if(tl.title == '' || tl.title == null || tl.title == undefined) {
        titleLang = false;
        tl.valid = false;
      } else {
        tl.valid = true;
      }
      return tl;
    });
    return !this.isTitleInvalid && gExamCreateSpan.isValid() && titleLang;
  }

  /**
   * 多言語用 : 別言語での受検コース名の入力欄を増加
   */
  handleAddTitleLang() {
    this.titleLanguages.push({
      langCode: 'ja',
      title: '',
      valid: true,
    } as EvalSettingTitleLang);
  }

  /**
   * 多言語用 : 別言語での受検コース名の入力欄を削除
   */
  handleDeleteTitleLang(index: number) {
    this.titleLanguages.splice(index, 1);
  }
}
